import React from 'react'
import styles from './AppHeader.module.scss';

import { useDate } from '../../helpers/general';
import { useApp } from '../../helpers/appContext';

function AppHeader() {
    const today = useDate();
    const { appType, mode } = useApp();

    let appLabel = '';
    if (appType && !mode)
        appLabel = appType
    else if (appType && mode)
        appLabel = `${appType} - ${mode}`;

    return (
        <div className={styles.AppHeader}>
            <div>
                <div>
                    {appLabel}
                </div>
                <div>
                    {`${today.date} - ${today.time}`}
                </div>
            </div>
        </div>
    )
}

AppHeader.propTypes = {}

export default AppHeader
